"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('trade-name-concepts.ts', shared_1.Styles.bracelet, util_1.inspect);
/******************************************** HELPERS *********************************************/
/**
 * TradeNameConcept factory: instantiate TradeNameConcept from data in trade-name-concepts.json
 */
var buildTradeNameConcept = function (tradeNameConcept) {
    return new javelin_exports_1.TradeNameConcept(tradeNameConcept.conceptId, tradeNameConcept.snomedCTId, kotlin_map_factory_1.dirtyKotlinMap(tradeNameConcept.preferredTerms), kotlin_map_factory_1.dirtyKotlinMap(tradeNameConcept.displayTerms), tradeNameConcept.parentId, tradeNameConcept.DIN, tradeNameConcept.manufacturer, tradeNameConcept.gtins);
};
/****************************************** DATA EXPORT *******************************************/
// Memoized array of TradeNameConceptInstance objects built from raw content data
var _tradeNameConcepts;
/**
 * Export array of TradeNameConcept objects [lazy]
 * Build collection on 1st run, then memoize (the content data is immutable)
 */
exports.tradeNameConcepts = function (rawContentData) {
    _tradeNameConcepts =
        _tradeNameConcepts || rawContentData.tradeNameConcepts.map(buildTradeNameConcept);
    log.verbose("tradeNameConcepts export:", util_1.inspect(_tradeNameConcepts, false, 10, true));
    return _tradeNameConcepts;
};
//# sourceMappingURL=trade-name-concepts.js.map